import { render, staticRenderFns } from "./edit_blog.vue?vue&type=template&id=3ccf82e2&scoped=true&"
import script from "./edit_blog.vue?vue&type=script&lang=js&"
export * from "./edit_blog.vue?vue&type=script&lang=js&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccf82e2",
  null
  
)

export default component.exports